import { getAppVersion } from "cd-eft/utils/sysUtils";
import React from "react";
import './ReportTitle.scss';

export interface IReportTitleProps {
    title: string;
}
export const ReportTitle = (props: IReportTitleProps) => {
    return (
        <div className='row formula-report-title'>
            <div className='col'>
                <h1 tabIndex={3}>{props.title}</h1>
                <span tabIndex={4}>NRCS - NETS</span>
            </div>
        </div>
    )
}